<div class="flex-center-column full-width">
  <div class="update-dialog light-content-panel light-control-host double-margin-top">
    <div *ngIf="loadingAccessTemplates; else templatesLoaded">
      <h1><i class="fa-solid fa-spinner fa-spin"></i> Loading updated access templates...</h1>
    </div>
    <ng-template #templatesLoaded>
      <h1>Let's get you updated.</h1>
      <ng-template [ngIf]="applicationType === 'aws'">
        <div class="margin-top">
          We've enhanced {{ uiService.productName }}, but to get this new functionality you'll need to update the
          CloudFormation stacks that grant {{ uiService.productName }} limited access to your AWS environment.
        </div>

        <aws-account-access-view
          class="margin-top"
          [state]="sourceAccessService.state"
          [stackName]="sourceAccessService.stack"
          [accessType]="Scope.SOURCE"
          [templateUrl]="sourceAccessTemplate"
          [awsAccountId]="sourceAccountId"
          [region]="sourceRegion"
          [completedTestCount]="sourceAccessService.tests"
          (buttonClicked)="sourceAccessService.validateAccess()"
        >
        </aws-account-access-view>
        <aws-account-access-view
          class="margin-top"
          [state]="targetAccessService.state"
          [stackName]="targetAccessService.stack"
          [accessType]="Scope.TARGET"
          [templateUrl]="targetAccessTemplate"
          [awsAccountId]="targetAccountId"
          [region]="targetRegion"
          [completedTestCount]="targetAccessService.tests"
          (buttonClicked)="targetAccessService.validateAccess()"
        >
        </aws-account-access-view>

        <stacksets-instructions
          *ngIf="stackSetsEnabled"
          class="margin-top"
          [sourceStackSetTemplateUrl]="sourceStackSetTemplateUrl"
          [targetStackSetTemplateUrl]="targetStackSetTemplateUrl"
          [sourceTemplateBucket]="sourceTemplateBucket"
          [sourceTemplateKey]="sourceTemplateKey"
          [targetTemplateBucket]="targetTemplateBucket"
          [targetTemplateKey]="targetTemplateKey"
          [sourceAccountId]="sourceAccountId"
          [sourceRegion]="sourceRegion"
          [targetAccountId]="targetAccountId"
          [targetRegion]="targetRegion"
          [sourceStackName]="sourceAccessService?.stack"
          [targetStackName]="targetAccessService?.stack"
        ></stacksets-instructions>
      </ng-template>

      <ng-template [ngIf]="applicationType === 'azure'">
        <div class="margin-top">
          We've enhanced {{ uiService.productName }}, but to get this new functionality you'll need to update the
          Deployment Stacks that grant {{ uiService.productName }} limited access to your Azure environment.
        </div>

        <azure-access-view
          class="margin-top"
          [state]="targetAccessService.state"
          [accessType]="Scope.TARGET"
          [installCommand]="targetInstallCommand"
          [subscriptionId]="targetAccountId"
          [region]="targetRegion"
          [completedTestCount]="targetAccessService.tests"
          (buttonClicked)="targetAccessService.validateAccess()"
        >
        </azure-access-view>
        <azure-access-view
          class="margin-top"
          [state]="sourceAccessService.state"
          [accessType]="Scope.SOURCE"
          [installCommand]="sourceInstallCommand"
          [subscriptionId]="sourceAccountId"
          [region]="sourceRegion"
          [completedTestCount]="sourceAccessService.tests"
          (buttonClicked)="sourceAccessService.validateAccess()"
        >
        </azure-access-view>
      </ng-template>

      <div class="flex-center-row margin-top">
        <div class="spacer"></div>
        <button type="button" class="arpio-secondary-button" (click)="onCancel()">CANCEL</button>
        <button type="button" class="arpio-button margin-left" [disabled]="!accessChecksComplete" (click)="onFinish()">
          FINISH
        </button>
      </div>
    </ng-template>
  </div>
</div>
